import HTTPClient from '@elab/core/utils/HTTPClient';
import apiUtils from '@elab/core/utils/apiUtils';

const getApiService = () => `${apiUtils.getBaseUri()}/users/current`;

const saveConsents = async consentsDto => {
    const uri = `${getApiService()}/consents`;
    const response = await HTTPClient().postJson(uri, consentsDto);
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
    return response.json();
};

const getConsentTemplates = async () => {
    const uri = `${getApiService()}/consenttemplates`;
    const response = await HTTPClient().getNoCache(uri);
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
    return response.json();
};

const getConsentGroups = async () => {
    const uri = `${getApiService()}/consentgroups`;
    const response = await HTTPClient().getNoCache(uri);
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
    return response.json();
};

export default {
    getConsentGroups,
    saveConsents,
    getConsentTemplates,
};
